




































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import dayjs from "dayjs";
@Component({
    components: {
      
    },
})
export default class logoutPanel extends Vue {
    public $refs: {
    };
    @Prop({
        default:false
    }) 
    show:Boolean;
    @Prop({
        default:""
    }) 
    title:String;
    @Prop({
        default:""
    }) 
    text:String;
    @Prop({
        default:""
    }) 
    confirmText:String;
    @Prop({
        default:""
    }) 
    cancelText:String;
    @Prop({
        default:1
    }) 
    btnNums:Number;

    created() {
    }
    mounted() {
     
        
    }

    confimrFun(){
        this.$emit("confimrFun");
    }

    cancelFun(){
        this.$emit("cancelFun");
    }

    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/logoutPanel.vue